import { Box, Grid } from "@mui/material";
import React from "react";
// import { Alert } from "react-alert";
import IconButton from "@material-ui/core/IconButton";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { observer } from "mobx-react-lite";
import Expand from "react-expand-animated";
import { IconContext } from "react-icons";
import { FiX } from "react-icons/fi";
import { Link, Redirect } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import MemberCard from "../../components/MemberCard2";
import TeamPopUp from "../../components/TeamPopUp";
import { saveProfile } from "../../services/PersonalService";
import {
  applyPosition,
  personalEvent,
  teamList,
  userList
} from "../../services/TeamService";
import { RootStoreContext } from "../../store";
import {
  ExpandCard,
  IconContainer,
  TopicDescription,
  TopicTitle
} from "./style";
import style from "./Team_list.module.css";
const { useState, useEffect, useCallback, useContext } = React;
const titleList = (members) => {
  const tl = [
    {
      title: "CEO",
      img: "",
      id: "",
    },
    {
      title: "CTO",
      img: "",
      id: "",
    },
    {
      title: "CFO",
      img: "",
      id: "",
    },
    {
      title: "CMO",
      img: "",
      id: "",
    },
    {
      title: "CDO",
      img: "",
      id: "",
    },
  ];
  for (let i = 0; i < tl.length; i++) {
    for (const key in members) {
      if (tl[i].title === members[key].title) {
        tl[i].id = members[key].id;
        tl[i].img = members[key].img;
      }
    }
  }
  return tl;
};
const Events = [{ type: null }];
const PosIcon = (props) => {
  const [pressed, setPressed] = useState(false);
  useEffect(() => {
    if (props.appliedBefore) {
      if (props.appliedPos === props.posName) setPressed(true);
    }
  }, []);
  if (!props.userId)
    return (
      <Stack spacing={0.5} alignItems="center">
        <div className={style.social}>
          <button
            disabled={pressed || props.applied || props.appliedBefore}
            style={{
              background: pressed ? "#C1C1C1" : "#ecb700",
            }}
            className={style.applyBtn}
            onClick={() => {
              if (window.confirm("確定申請該職位嗎？")) {
                window.alert("已經成功申請入隊，請等待團隊創建人同意。");
                applyPosition({ position: props.posName, id: props.id });
                setPressed(!pressed);
                props.setApplied(props.posName);
                console.log("pressed");
              }
            }}
          >
            申請
          </button>
        </div>
        <p className={style.titleName}>{props.posName}</p>
      </Stack>
    );
  else
    return (
      <Stack spacing={0.5} alignItems="center">
        <Link
          to={{ pathname: "/Profile_show", state: { id: props.userId } }}
          style={{ pointerEvents: !props.userId && "none" }}
        >
          <div className={style.social}>
            <img
              src={props.img}
              className={style.social}
              style={{ visibility: props.img === "" && "hidden" }}
              alt=""
            />
          </div>
        </Link>
        <p className={style.titleName}>{props.posName}</p>
      </Stack>
    );
};

const EventMsg = ({ event, refresh }) => {
  const [check, setCheck] = useState(false);
  const toggle = () => {
    setCheck(!check);
  };
  if (event.type === "apply") {
    return (
      <Stack spacing={1}>
        <Typography variant="h8">
          {event.applicant}想要申請{event.position}職位。
        </Typography>
        <Stack direction="row" spacing={2} alignItems="center">
          <div className={style.applicantInfoBox}>
            <div className={style.applicantInfo}>
              <Stack direction="row" spacing={2} alignItems="center">
                <Link
                  to={{
                    pathname: "/Profile_show",
                    state: { id: event.applicantId },
                  }}
                >
                  <div
                    style={{
                      backgroundImage:
                        event.applicantImg !== "" &&
                        `url(${event.applicantImg})`,
                    }}
                    className={style.social}
                  />
                </Link>
                <p className={style.applicantName}>{event.applicant}</p>
              </Stack>
            </div>
          </div>
          <button className={style.allowBtn}>允許</button>
        </Stack>
      </Stack>
    );
  } else if (event.type === "allow") {
    return (
      <Typography variant="h8">
        {event.name}允許{event.applicant}加入團隊。
      </Typography>
    );
  } else if (event.type === "leave") {
    return <Typography variant="h8">抱歉{event.name}退出了團隊。</Typography>;
  } else if (event.type === "invite") {
    return (
      <>
        <Typography color="#575757" marginLeft="2%">
          {event.teamName}邀請您成為團隊{event.position}！
        </Typography>
        <Stack direction="row" spacing={2} alignItems="center">
          <Box className={style.teamInfo}>
            <Typography paddingLeft="15%" paddingTop="10%" fontSize="1.5em">
              {event.teamName}
            </Typography>
            <Box className={style.field} padding="2% 5%" margin="5% 13%">
              {event.teamField}
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                padding: "0 6% 3% 0",
              }}
            >
              <Typography fontSize="0.8em" color="#C9C9C9">
                目前隊伍人數：2
              </Typography>
            </Box>
          </Box>
          <button className={style.check_btn} onClick={toggle}>
            <Typography fontSize="1em" color="#575757">
              查看
            </Typography>
          </button>
        </Stack>
        {check ? (
          <TeamPopUp
            name={event.teamName}
            field={event.teamField}
            ideation={event.teamDescription}
            pos={event.position}
            toggle={toggle}
            refresh={refresh}
            teamInfo={{ teamId: event.teamId, teamEventId: event.teamEventId }}
            eventId={event.eventId}
          />
        ) : null}
      </>
    );
  }
  return <Typography variant="h8">什麼訊息都沒收到。</Typography>;
};

const ImageAvatars = (props) => {
  // const [render, setRender] = useState(false);
  // const [id, setId] = useState("");
  // const [members, setMembers] = useState([]);
  const [applied, setApplied] = useState(false);
  // useEffect(() => {
  //   let tmp = { ...props };
  //   setId(tmp.id);
  //   setMembers(tmp.members);
  // }, [props]);
  useEffect(() => {
    if (applied != false) props.addTeam(applied);
  }, [applied]);
  return (
    <div className={style.imgs}>
      <Stack direction="row" spacing={4}>
        {titleList(props.members).map((item, index) => {
          return (
            <PosIcon
              key={index.toString()}
              posName={item.title}
              img={item.img}
              id={props.id}
              userId={item.id}
              appliedBefore={props.appliedBefore}
              appliedPos={props.appliedPos}
              applied={applied}
              setApplied={setApplied}
            />
          );
        })}
      </Stack>
    </div>
  );
};

const TeamBox = (props) => {
  const [open, setOpen] = useState(false);

  const toggle = () => {
    setOpen(!open);
  };
  const [teamInfo, setTeamInfo] = useState({
    members: [],
    id: "",
    field: "",
    ideation: "",
  });
  useEffect(() => {
    let tmp = { ...props };
    setTeamInfo(tmp.teamInfo);
    // props.forceUpdate();
  }, [props]);

  const transitions = ["height", "opacity", "background"];
  return (
    <>
      <div className={style.TeamBox}>
        <ImageAvatars
          members={teamInfo.members}
          id={teamInfo.id}
          appliedBefore={props.applied}
          appliedPos={props.appliedPos}
          addTeam={props.addTeam}
        />
        <IconButton
          edge="start"
          onClick={() => {
            toggle();
          }}
          className={style.expandBtn}
          style={{ transform: !open && "rotate(180deg)" }}
        >
          <KeyboardArrowDownIcon />
        </IconButton>
      </div>
      <Expand open={open} duration={1000} transitions={transitions}>
        <div className={style.introBox}>
          <Stack
            direction="row"
            alignItems="center"
            style={{ marginTop: "17.46px", marginLeft: "49px" }}
            spacing={49}
          >
            <div className={style.fieldBox}>
              <Box mr={1} ml={1} mt={0.4}>
                {teamInfo.field}
              </Box>
            </div>
          </Stack>
          <p className={style.ideationTxt}>{teamInfo.ideation}</p>
        </div>
      </Expand>
    </>
  );
};

const memberData = {
  id: "12345678",
  first_name: "Shambhavi",
  last_name: "Mishra",
  avatar_url:
    "https://media.zenfs.com/zh-tw/petsmao_nownews_707/38fd0746221775e3ec2c94ba5fa6c0d6",
  des: "Shambhavi is a well-rounded web publisher with 15 years experience working.",
  ig_link: "https://www.instagram.com/ericchien21/",
  linkin_link: "https://www.instagram.com/ericchien21/",
  tiktok_link: "https://www.instagram.com/ericchien21/",
};

const wait = (ms) => {
  var start = new Date().getTime();
  var end = start;
  while (end < start + ms) {
    end = new Date().getTime();
  }
};

const Team_list = () => {
  const [mode, setMode] = useState("team");
  const [RWD, setRWD] = useState(false);
  const handleMode = (option) => {
    setMode(option);
  };
  const [width, setWindowWidth] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => setLoading(false), 3000);
  }, []);
  useEffect(() => {
    updateDimensions();

    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);
  const updateDimensions = () => {
    const width = window.innerWidth;
    setWindowWidth(width);
    setRWD(width < 1339);
  };
  const { PersonalStore, TeamListStore } = useContext(RootStoreContext);
  const { applyTeam, addTeam } = PersonalStore;
  const { teamlist } = TeamListStore;
  const [teams, setTeams] = useState(teamlist);
  const [events, setEvents] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [, updateState] = useState();
  const forceUpdate = useCallback(() => updateState({}), []);
  const [hintVisible, setHintVisible] = useState(true);
  const handleApplication = (teamId, pos) => {
    addTeam(teamId, pos);
    let tmp = {};
    if (applyTeam["teamId"]) tmp = applyTeam;
    else {
      tmp = { ...applyTeam };
      tmp[teamId] = pos;
    }
    saveProfile({ applyTeam: tmp });
  };
  useEffect(() => {
    teamList()
      .then((value) => {
        setTeams(value);
      })
      .catch(console.log);
    if (events.length !== 0) wait(1000);
    personalEvent().then((value) => {
      setEvents(value.length > 5 ? value.reverse().slice(0, 5) : value);
    });
  }, [refresh]);

  const [users, setUsers] = useState([]);
  useEffect(() => {
    userList().then((value) => {
      const tmp = [];
      for (let i = 0; i < Number(value.length / 3); i += 3) {
        tmp.push(
          i === value.length - (value.length % 3)
            ? value.slice(i, value.length)
            : value.slice(i, i + 3)
        );
      }
      setUsers(tmp);
    });
  }, []);

  if (loading) return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
      <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
        <BeatLoader loading={loading} />
        <p>Loading...</p>
      </div>
    </div>
  );

  return (
    <Grid
      container
      className={style.main}
      direction="row"
      justifyContent="center"
      alignItems="flex-start"
    >
      <Grid item sm={6} md={6}>
        <div style={{ width: "616px" }}>
          {hintVisible && (
            <ExpandCard>
              <div>
                <TopicTitle>嗨大家好！歡迎進入susu平台。</TopicTitle>
                <TopicDescription>
                  第一步，我們將要組建一隻隊伍。以下大家可以選擇：創建隊伍一隻自己的隊伍，或是“申請”加入其他成員未滿的同學的團隊。
                  btw 點擊同學頭貼將可以查看隊伍意見喔~
                </TopicDescription>
              </div>
              <IconContainer
                onClick={() => {
                  setHintVisible(false);
                }}
              >
                <IconContext.Provider value={{ size: 21, color: "#C8C8C8" }}>
                  <FiX />
                </IconContext.Provider>
              </IconContainer>
            </ExpandCard>
          )}
          <Stack
            direction="row"
            justifyContent="flex-start"
            spacing={10}
            sx={{
              marginLeft: "5%",
              marginBottom: "5%",
            }}
          >
            <Button
              disabled={mode === "team"}
              onClick={() => {
                handleMode("team");
              }}
            >
              <Typography
                variant="h5"
                style={{
                  fontWeight: 700,
                  color: mode !== "team" ? "#BFBDBD" : "#575757",
                  whiteSpace: "nowrap",
                }}
              >
                配對隊伍
              </Typography>
            </Button>
            <Button
              disabled={mode === "member"}
              onClick={() => {
                handleMode("member");
              }}
            >
              <Typography
                variant="h5"
                style={{
                  fontWeight: 700,
                  color: mode !== "member" ? "#BFBDBD" : "#575757",
                  whiteSpace: "nowrap",
                }}
              >
                使用者列表
              </Typography>
            </Button>
            <Button
              disabled={mode === "event"}
              onClick={() => {
                handleMode("event");
              }}
              style={{
                visibility: width > 1339 && "hidden",
              }}
            >
              <Typography
                variant="h5"
                style={{
                  fontWeight: 700,
                  color: mode === "event" ? "#575757" : "#BFBDBD",
                }}
              >
                事件
              </Typography>
            </Button>
            <Link to={"/team-3"}>
              <button
                style={{ visibility: mode !== "team" && "hidden" }}
                className={style.createBtn}
              >
                創建隊伍
              </button>
            </Link>
          </Stack>
        </div>
        <div
          style={{
            display: mode !== "team" && "none",
          }}
        >
          <Stack spacing={4}>
            {teams.map((item, index) => {
              // console.log(item);
              return (
                <div>
                  <Box mb={1} ml={2}>
                    <Typography
                      variant="h6"
                      style={{ color: "#575757", fontWeight: "700" }}
                    >
                      {item.teamname ? item.teamname : <br />}
                    </Typography>
                  </Box>
                  <TeamBox
                    teamInfo={item}
                    applied={applyTeam[item.id] !== undefined}
                    addTeam={(pos) => handleApplication(item.id, pos)}
                    forceUpdate={forceUpdate}
                    appliedPos={applyTeam[item.id]}
                  />
                </div>
              );
            })}
          </Stack>
        </div>
        <div
          style={{
            display: mode !== "member" && "none",
          }}
        >
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="flex-start"
            spacing={6}
          >
            {users.map((ug) => {
              return (
                <Stack
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  spacing={6}
                >
                  {ug.map((user) => {
                    return <MemberCard memberData={user} />;
                  })}
                </Stack>
              );
            })}
          </Stack>
        </div>
        <div
          style={{
            display: mode !== "event" && "none",
          }}
        >
          <Stack spacing={2}>
            {events.length > 0
              ? events.map((item) => {
                return (
                  <EventMsg
                    event={item}
                    refresh={() => {
                      setRefresh(!refresh);
                    }}
                  />
                );
              })
              : "沒有任何事件"}
          </Stack>
        </div>
      </Grid>
      <Grid item sm md style={{ visibility: width < 1339 && "hidden" }}>
        <div>
          <Typography
            color="#575757"
            variant="h5"
            style={{ fontWeight: 700, visibility: width < 1339 && "hidden" }}
            className={style.eventTitle}
          >
            事件
          </Typography>
          <div style={{ marginTop: "28.65px" }}>
            <Stack spacing={2}>
              {events.length > 0
                ? events.map((item) => {
                  return (
                    <EventMsg
                      event={item}
                      refresh={() => {
                        setRefresh(!refresh);
                      }}
                    />
                  );
                })
                : "沒有任何事件"}
            </Stack>
          </div>
        </div>
      </Grid>
    </Grid>
  );
};

export default observer(Team_list);
